import { render, staticRenderFns } from "./dashboard-rank-product-header.vue?vue&type=template&id=1d3726da&scoped=true&"
import script from "./dashboard-rank-product-header.vue?vue&type=script&lang=js&"
export * from "./dashboard-rank-product-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3726da",
  null
  
)

export default component.exports